//PrevNextExtent.tsx ==============================================================
import "../Util/Prototypes";

import * as MainMap from "../MainMap";
import * as QueryString from "../QueryString";
import * as Util from "../Util/Util";

import Extent from "@arcgis/core/geometry/Extent";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";

import React from "react";
import ReactDOM from "react-dom/client";

export let prevDiv: HTMLElement;
export let nextDiv: HTMLElement;

interface iExtent {
   xmin: number;
   ymin: number;
   xmax: number;
   ymax: number;
   wkid: number;
}

let ii: number; //Index of extent history array.
let _hist: iExtent[]; //Array of extent history.
let _prevClicked: boolean = false;
let _nextClicked: boolean = false;
let root: ReactDOM.Root;

//Render all components in the html content div.
export function render() {
   Util.logMsg("Rendering div for Prev Next extent buttons.");
   if (!root) {
      root = ReactDOM.createRoot(document.getElementById("prevNextDiv"));
   }
   root.render(<Render />);
}

//Create previous and next extent buttons.
export function createPrevNextButtons() {
   if (prevDiv) {
      MainMap.mapView.ui.add(prevDiv, "top-right");
   }
   if (nextDiv) {
      MainMap.mapView.ui.add(nextDiv, "top-right");
   }
}

//Initialize tool.
export function init() {
   Util.logMsg('Initializing PrevNextExtent Module');
   _hist = [];

   //Load extent history.
   if (localStorage.Exists("extentHistoryTS")) {
      _hist = localStorage.GetItem("extentHistoryTS") as iExtent[];

      //Util.logMsg('Loaded extent history length:' + _hist.length, _hist);

      if (_hist.length > 30) {
         _hist.splice(0, _hist.length - 30); //Cull the herd of extents a bit.
         //Util.logMsg('Truncated extent history count to ' + _hist.length);
      }
   }

   ii = _hist.length - 1;
   //Util.logMsg('Initial history index: ' + ii);

   //Get history index if user last pressed previous or next buttons.
   if (localStorage.Exists("extentHistIndexTS") && _hist.length > 0) {
      ii = Util.parseInteger(localStorage.GetItem("extentHistIndexTS") as string);
      //Util.logMsg('History index from local storage: ' + ii);
   }

   reactiveUtils.when(() => MainMap.mapView?.stationary === true, map_onExtentChange);
}

//Map extent changed.
function map_onExtentChange() {
   if (!MainMap.mapView || !MainMap.mapView.extent || !MainMap.mapView.extent.xmin || MainMap.startUpInProgress) {
      return; //Quit if in 3D mode or starting up.
   }

   if (ii !== -1) {
      if (!_hist[ii]) {
         return; //Quit if not ready.
      }
   }

   //Set index of extent history in local storage.
   if (_prevClicked || _nextClicked) {
      localStorage.SetItem("extentHistIndexTS", ii.toString());
      //Util.logMsg('Saved history index to local storage: ' + ii);
      _prevClicked = false;
      _nextClicked = false;

   } else { //Add new map extent to history array.
      localStorage.RemoveItem("extentHistIndexTS"); //Remove history index.
      //Util.logMsg('Deleted history index in local storage');

      //Check for same extent as previous.
      let theSame = false;
      if (_hist.length > 0 && _hist[ii].xmin) {
         if (Math.round(MainMap.mapView.extent.xmin) === Math.round(_hist[ii].xmin)) {
            theSame = true;
            //Util.logMsg('Map extents are the same.');
         }
      }

      if (!theSame) {
         if (ii < (_hist.length - 1)) {
            _hist = _hist.slice(0, ii + 1); //Resetting extent history for new extent when viewing previous extents.
            //Util.logMsg('Reset extent history for new extent when viewing previous extents.');
            //Util.logMsg('History count: ' + _hist.length + ' Index: ' + ii);
         }

         const extent: iExtent = { xmin: MainMap.mapView.extent.xmin, ymin: MainMap.mapView.extent.ymin, xmax: MainMap.mapView.extent.xmax, ymax: MainMap.mapView.extent.ymax, wkid: MainMap.mapView.spatialReference.wkid };
         _hist.Add(extent);
         ii += 1;

         localStorage.SetItem("extentHistoryTS", _hist);
         //Util.logMsg('Added extent.  History count: ' + _hist.length + ' Index: ' + ii);
         //Util.logMsg('Extent: ' + MainMap.mapView.extent.xmin + ', ' + MainMap.mapView.extent.ymin + ', ' + MainMap.mapView.extent.xmax + ', ' + MainMap.mapView.extent.ymax);
      }
   }
}

//Zoom to map extent.
function zoomToExtent() {
   const hist: iExtent = _hist[ii];
   if (hist && hist.xmin) {

      //   if (hist.wkid === MainMap.mapView.spatialReference.wkid) {
      const extent = new Extent({
         xmin: hist.xmin,
         ymin: hist.ymin,
         xmax: hist.xmax,
         ymax: hist.ymax,
         spatialReference: { wkid: hist.wkid },
      });
      MainMap.mapView.goTo(extent, { duration: 0 });
      //   }
   }
}

//Clear extent history.
export function clearHistory() {
   _hist = [];
   ii = -1;
   localStorage.RemoveItem("extentHistoryTS");
   localStorage.RemoveItem("extentHistIndexTS");
   Util.logMsg('Cleared map extent history');
}

interface iProps {
}

//Render function.
export function Render(props: iProps) {

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
      prevDiv = document.getElementById("prevExtentDiv");
      prevDiv.addEventListener('click', prevExtent, { capture: true, passive: true });

      nextDiv = document.getElementById("nextExtentDiv");
      nextDiv.addEventListener('click', nextExtent, { capture: true, passive: true });
   }, []);

   //Previous extent click event.
   function prevExtent() {
      QueryString.setZoomToStartExtent(false);

      if (ii === 0) {
         return;
      }
      _prevClicked = true;
      ii -= 1;
      zoomToExtent();
   }

   //Next extent click event.
   function nextExtent() {
      if (ii === _hist.length - 1) {
         return;
      }
      _nextClicked = true;
      ii += 1;
      zoomToExtent();
   }

   //Enable controls. Difficult because refreshing with react disables prevExtent onClick event.
   function enableAll() {
      //("#prevExtent").Disable();
      //("#nextExtent").Disable();
      //if (ii > 0) {
      //   ("#prevExtent").Enable();
      //}
      //if (ii < (_hist.length - 1)) {
      //   ("#nextExtent").Enable();
      //}
   }

   //Create button html.
   return (
      <div>
         <div id="prevExtentDiv"
            className="esri-widget--button esri-widget esri-interactive" role="button" tabIndex={0} title="Go to previous map extent">
            <span aria-hidden="true" role="presentation" className="esri-icon-left-arrow"></span>
            <span className="esri-icon-font-fallback-text">Prev</span>
         </div>

         <div id="nextExtentDiv"
            className="esri-widget--button esri-widget esri-interactive" role="button" tabIndex={0} title="Go to next map extent">
            <span aria-hidden="true" role="presentation" className="esri-icon-right-arrow"></span>
            <span className="esri-icon-font-fallback-text">Next</span>
         </div>
      </div>
   ); //end return.

} //end function.
